import dayjs from "dayjs";
import { DISPLAY_DATE, YYYY_MM_DD } from "constants/date";
import { DiscountType } from "store/apis/couponAdmin";
import { BackendError } from "types/utils/error";

export const getCouponSignupLink = (couponCode: string) =>
  `${window.location.origin}/signup?couponCode=${encodeURIComponent(
    couponCode
  )}`;

// Date pickers store YYYY-MM-DD; the API needs timezone-aware datetimes
export const toStartOfDayIso = (date: string) =>
  dayjs(date).startOf("day").toISOString();

export const toEndOfDayIso = (date: string) =>
  dayjs(date).endOf("day").toISOString();

export const toDateInputValue = (datetime?: string | null) =>
  datetime ? dayjs(datetime).format(YYYY_MM_DD) : "";

// Default dates for new coupons and task discounts
export const getTodayInputValue = () => dayjs().format(YYYY_MM_DD);

export const getOneYearFromTodayInputValue = () =>
  dayjs().add(1, "year").format(YYYY_MM_DD);

export const formatDate = (datetime?: string | null) =>
  datetime ? dayjs(datetime).format(DISPLAY_DATE) : "—";

export const formatDiscount = (
  discountType: DiscountType,
  discountRate: number | null
) => {
  if (discountRate === null) {
    return "—";
  }
  return discountType === "PERCENT" ? `${discountRate}%` : `$${discountRate}`;
};

export const getErrorMessage = (err: unknown) =>
  (err as BackendError)?.data?.error?.message ?? "Something went wrong";

export const DISCOUNT_TYPE_OPTIONS = [
  { label: "Percent (%)", value: "PERCENT" },
  { label: "Absolute ($)", value: "ABSOLUTE" },
];

export const DURATION_TYPE_OPTIONS = [
  { label: "Forever", value: "FOREVER" },
  { label: "Monthly", value: "MONTHLY" },
];
